import { render, staticRenderFns } from "./TepBloqueMapPoli.vue?vue&type=template&id=65b067f3"
import script from "./TepBloqueMapPoli.vue?vue&type=script&lang=js"
export * from "./TepBloqueMapPoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports